import { customElement as litCustomElement } from 'lit/decorators/custom-element.js';

export function customElement(tagName: string) {
  return (classOrTarget: any, context?: any) => {
    // Set .is so that other decorators and utilities can read the tag name
    classOrTarget.is = tagName;

    // Delegate to Lit's original decorator
    return litCustomElement(tagName)(classOrTarget, context);
  };
}
